module.exports = __webpack_public_path__ + "img/04-7.33562450.png";